// extracted by mini-css-extract-plugin
export var header = "header-module--header--b6ebd";
export var header__placeholder = "header-module--header__placeholder--7749c";
export var header__promoBannerPlaceholder = "header-module--header__promo-banner-placeholder--aa06c";
export var mt0 = "header-module--mt-0--7ec77";
export var mt1 = "header-module--mt-1--a42ac";
export var mt2 = "header-module--mt-2--9426b";
export var mt3 = "header-module--mt-3--0dc91";
export var mt4 = "header-module--mt-4--921fd";
export var mt5 = "header-module--mt-5--7c26d";
export var mt6 = "header-module--mt-6--e5073";